import React from 'react';
import { useNavigate } from 'react-router-dom';

import { payslips } from './data';
import { formatLabel, formatDescription, formatAmount } from './formatting';

export default function Payslips() {
  const navigate = useNavigate();

  const handleClick = (idx: number) => () => {
    navigate(`/payslips/${idx}${window.location.search.toString()}`);
  };

  return (
    <div className="m-16 list">
      <table>
        <thead>
          <tr>
            <th>Period</th>
            <th>Total amount</th>
          </tr>
        </thead>
        <tbody>
          {
            payslips.map((payslip, idx) => (
              <tr key={payslip.month} onClick={handleClick(idx)} role="button" className="clickable">
                <td>
                  <div className="list-label">{formatLabel(payslip.month)}</div>
                  <div className="list-description">{formatDescription(payslip.month)}</div>
                </td>
                <td>
                  <div className="list-value">{formatAmount(payslip.amount)}</div>
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}
